import { useState , memo } from "react";
import drawPath from "../../utils/drawPath";
import editorAction from "../../actions/editorAction";
import usePath from "../../hook/path/usePath";
import useShiftKey from "../../hook/useShiftKey";

function Path({path_id, parent_block_id, child_block_id }) {

    const { searchPath, deletePath } = usePath();

    const path = searchPath({path_id, parent_block_id, child_block_id });

    const { shiftKey } = useShiftKey();

    if(!path) {
        return (<></>)
    }

    const { x, y, _x, _y, height, _height, index, action_type, renderPosition } = path;

    const {data, stroke} = drawPath(x, y, _x, _y, height, _height, index, action_type, renderPosition);

    const onMouseEnter = (e) => {
        if(shiftKey == true) return;
        e.target.style.stroke = "var(--pink)"
    }
    
    const onMouseLeave = (e) => {
        if(shiftKey == true) return;
        e.target.style.stroke = "";
    }

    const onClick = (e) => {
        if(shiftKey == true) return;
        deletePath(path_id);
    }
    return (
        <path id={path_id} d={data} style={{ cursor : shiftKey == true ? "not-allowed" : "pointer", transition : "stroke 0.4s ease 0s"}} strokeWidth="2px" fill="none" stroke={stroke} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={onClick}></path>
    )
}

// This part is useful for optimization, when the path is rendered we don't touch it from outside (cost to must ressources with rerender, the component wil rerender it self if needed)
export default memo(Path, function(prevPath, nextPath) {
    return prevPath.path_id == nextPath.path_id;
});
